import { render, staticRenderFns } from "./LoaderRoller.vue?vue&type=template&id=058430b8&scoped=true&"
import script from "./LoaderRoller.vue?vue&type=script&lang=js&"
export * from "./LoaderRoller.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRoller.vue?vue&type=style&index=0&id=058430b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058430b8",
  null
  
)

export default component.exports